import DateCell from '../../../../elements/Table/Cells/DateCell'
import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'

function PaymentScheduleList(props) {
  const { list, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Description',
      accessor: 'name',
    },
    { Header: 'Amount', accessor: 'amount', Footer: SumFooter },
    { Header: 'Date', accessor: 'date', Cell: DateCell },
    // {Header: 'Currency', accessor: 'currency'},
    { Header: 'Status', accessor: 'status' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
    />
  )
}

PaymentScheduleList.propTypes = {}
PaymentScheduleList.defaultProps = {}

export default PaymentScheduleList
